export enum TabsEnum {
  INBOX = 0,
  CHANGES = 1,
  OVERVIEW = 2,
  ARCHIVE = 3
}
